import { User, ChevronDown, ChevronUp } from "lucide-react";
import { formatDuration, formatTimestamp, zoneColors } from "./utils";
import ZonePath from "./ZonePath";

const IndividualReid = ({ reid, journeys, stats, isExpanded, onToggle }) => {
  return (
    <div className="reid-individual-card">
      <div
        className="reid-individual-header"
        onClick={onToggle}
      >
        <div className="reid-individual-header-content">
          <div className="reid-individual-info">
            <div className="reid-individual-avatar">
              <User size={24} />
            </div>
            <div className="reid-individual-details">
              <h3>REID {reid}</h3>
              <p>
                Last active:{" "}
                {stats.mostRecent
                  ? new Date(stats.mostRecent).toLocaleDateString()
                  : "N/A"}
              </p>
            </div>
          </div>

          <div className="reid-individual-stats">
            <div className="reid-individual-stat">
              <div className="reid-individual-stat-value reid-individual-stat-value-blue">
                {stats.journeyCount}
              </div>
              <div className="reid-individual-stat-label">Events</div>
            </div>

            <div className="reid-individual-stat">
              <div className="reid-individual-stat-value reid-individual-stat-value-green">
                {stats.zoneCount}
              </div>
              <div className="reid-individual-stat-label">Zones</div>
            </div>

            <div className="reid-individual-stat">
              <div className="reid-individual-stat-value-large reid-individual-stat-value-purple">
                {formatDuration(stats.totalDwellTime)}
              </div>
              <div className="reid-individual-stat-label">Total Time</div>
            </div>

            <div className="reid-individual-chevron">
              {isExpanded ? <ChevronUp size={24} /> : <ChevronDown size={24} />}
            </div>
          </div>
        </div>

        {journeys.length > 0 && <ZonePath journeys={journeys} />}
      </div>

      {isExpanded && journeys.length > 0 && (
        <div className="reid-expanded-content">
          <div className="reid-expanded-stats">
            <div className="reid-expanded-stat-card reid-expanded-stat-card-blue">
              <div className="reid-expanded-stat-label reid-expanded-stat-label-blue">
                Total Dwell Time
              </div>
              <div className="reid-expanded-stat-value reid-expanded-stat-value-blue">
                {formatDuration(stats.totalDwellTime)}
              </div>
            </div>
            <div className="reid-expanded-stat-card reid-expanded-stat-card-green">
              <div className="reid-expanded-stat-label reid-expanded-stat-label-green">
                Average Dwell Time
              </div>
              <div className="reid-expanded-stat-value reid-expanded-stat-value-green">
                {formatDuration(stats.avgDwellTime)}
              </div>
            </div>
            <div className="reid-expanded-stat-card reid-expanded-stat-card-purple">
              <div className="reid-expanded-stat-label reid-expanded-stat-label-purple">
                Most Visited Zone
              </div>
              <div className="reid-expanded-stat-value reid-expanded-stat-value-purple">
                {stats.mostVisitedZone}
              </div>
            </div>
            <div className="reid-expanded-stat-card reid-expanded-stat-card-orange">
              <div className="reid-expanded-stat-label reid-expanded-stat-label-orange">
                Unique Zones
              </div>
              <div className="reid-expanded-stat-value reid-expanded-stat-value-orange">
                {stats.zoneCount}
              </div>
            </div>
          </div>

          <div className="reid-journey-details">
            <h5 className="reid-journey-title">
              Journey Details
            </h5>
            <div className="reid-journey-table-container">
              <table className="reid-journey-table">
                <thead>
                  <tr>
                    <th>#</th>
                    <th>Zone</th>
                    <th>Timestamp</th>
                    <th>Dwell Time</th>
                  </tr>
                </thead>
                <tbody>
                  {journeys.map((journey, idx) => (
                    <tr key={idx}>
                      <td className="reid-journey-table-index">{idx + 1}</td>
                      <td>
                        <span
                          className="reid-zone-badge"
                          style={{
                            backgroundColor:
                              zoneColors[journey.zone_name] ||
                              zoneColors.default,
                          }}
                        >
                          {journey.zone_name}
                        </span>
                      </td>
                      <td className="reid-journey-table-timestamp">
                        {formatTimestamp(journey.timestamp)}
                      </td>
                      <td className="reid-journey-table-dwell">
                        {formatDuration(journey.dwell_time)}
                      </td>
                    </tr>
                  ))}
                </tbody>
              </table>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};


export default IndividualReid;
